/** Seed mock data inspired by HTML preview — used only when API returns empty. */

import { PIPELINE_STAGE_COLORS } from './PipelineStageStatusCard';
import {
  computeFundingAmountCardTotals,
  sumApprovedByProductCategories,
} from './fundingApplicationDisplay';

export const MOCK_APPLICATIONS = [
  {
    id: 'mock-app-1',
    dateOfApplication: '2025-11-14',
    entityId: 'entity_ms_beauty',
    entityLabel: 'MS Beauty Studio LLC',
    applicantOwnerIds: ['owner_marie', 'owner_jean'],
    applicants: [
      { ownerId: 'owner_marie', roleOnApplication: 'Primary Applicant', ownershipPercentUsed: 70 },
      { ownerId: 'owner_jean', roleOnApplication: 'Co-applicant', ownershipPercentUsed: 30 },
    ],
    applicantPills: [{ name: 'Marie', percent: 70 }, { name: 'Jean', percent: 30 }],
    source: 'manual',
    uploadedFileName: '',
    scanStatus: '',
    lender: 'Chase',
    lendingProduct: '0% Business Credit Card',
    applicationType: 'Business PG',
    personalOrBusiness: 'Business',
    zeroPercentOffer: 'Yes',
    approvalAmount: 25000,
    decision: 'Approved',
    zeroPercentTerm: '12 months',
    pipelineStage: 'funded',
    selectedBureauPull: 'experian',
    bureauPullScores: { experian: 724, transunion: 718, equifax: 731 },
    ownerName: 'Marie Samuelle',
    ssnMasked: '***-**-6789',
    ssnLast4: '6789',
    dob: '1988-11-06',
    fullEin: '88-4821931',
    einMasked: '**-***1931',
    businessLegalName: 'MS Beauty Studio LLC',
    businessStartDate: '2021-03-14',
    employerName: 'Self-employed',
    timeLiveInHouseYears: 4,
    timeLiveInHouseMonths: 0,
    timeWorkingAtYears: 6,
    timeWorkingAtMonths: 0,
    experianScoreUsed: 724,
    transunionScoreUsed: 718,
    equifaxScoreUsed: 731,
    personalIncome: 92000,
    businessIncome: 186000,
    housing: 1800,
    businessExpenses: 4200,
    savings: 15000,
    retirementAccount: 28000,
    personalAddress: '211 Palm Ridge Dr, Orlando, FL',
    businessAddress: '44 Market Plaza, Orlando, FL',
    notes: 'Primary business card application',
  },
  {
    id: 'mock-app-2',
    dateOfApplication: '2025-10-02',
    entityId: 'entity_marie_personal',
    entityLabel: 'Marie Samuelle',
    applicantOwnerIds: ['owner_marie_personal'],
    applicants: [{ ownerId: 'owner_marie_personal', roleOnApplication: 'Primary Applicant', ownershipPercentUsed: 100 }],
    applicantPills: [{ name: 'Marie', percent: 100 }],
    source: 'uploaded_scan',
    uploadedFileName: 'amex-approval-screenshot.png',
    scanStatus: 'complete',
    lender: 'Amex',
    lendingProduct: 'Personal Loan',
    applicationType: 'Personal',
    personalOrBusiness: 'Personal',
    zeroPercentOffer: 'No',
    approvalAmount: 12000,
    decision: 'Approved',
    zeroPercentTerm: 'None',
    pipelineStage: 'funded',
    selectedBureauPull: 'experian',
    bureauPullScores: { experian: 720, transunion: 715, equifax: 728 },
    ownerName: 'Marie Samuelle',
    personalIncome: 92000,
    businessIncome: 186000,
    housing: 1800,
    businessExpenses: 4200,
    savings: 15000,
    retirementAccount: 28000,
    personalAddress: '211 Palm Ridge Dr, Orlando, FL',
    businessAddress: '44 Market Plaza, Orlando, FL',
    notes: '',
  },
  {
    id: 'mock-app-3',
    dateOfApplication: '2025-09-18',
    lender: 'Bank of America',
    lendingProduct: 'Business Line of Credit',
    applicationType: 'Business PG',
    personalOrBusiness: 'Business',
    zeroPercentOffer: 'No',
    approvalAmount: 11000,
    decision: 'Approved',
    zeroPercentTerm: 'None',
    pipelineStage: 'approved',
    selectedBureauPull: 'equifax',
    bureauPullScores: { experian: 726, transunion: 719, equifax: 733 },
    ownerName: 'Marie Samuelle',
    ssnMasked: '***-**-6789',
    ssnLast4: '6789',
    experianScoreUsed: 726,
    transunionScoreUsed: 719,
    equifaxScoreUsed: 733,
  },
  {
    id: 'mock-app-4',
    dateOfApplication: '2025-08-05',
    lender: 'Capital One',
    lendingProduct: '0% Personal Credit Card',
    applicationType: 'Personal',
    personalOrBusiness: 'Personal',
    zeroPercentOffer: 'Yes',
    approvalAmount: 0,
    decision: 'Pending',
    zeroPercentTerm: '15 months',
    pipelineStage: 'submitted',
    selectedBureauPull: 'transunion',
    bureauPullScores: { experian: 722, transunion: 718, equifax: 725 },
    ownerName: 'Marie Samuelle',
    ssnMasked: '***-**-6789',
    ssnLast4: '6789',
    experianScoreUsed: 722,
    transunionScoreUsed: 718,
    equifaxScoreUsed: 725,
  },
  {
    id: 'mock-app-5',
    dateOfApplication: '2025-07-22',
    lender: 'Wells Fargo',
    lendingProduct: 'Business Loan',
    applicationType: 'Full-doc',
    personalOrBusiness: 'Business',
    zeroPercentOffer: 'No',
    approvalAmount: 0,
    decision: 'Denied',
    zeroPercentTerm: 'None',
    pipelineStage: 'submitted',
    selectedBureauPull: 'experian',
    bureauPullScores: { experian: 710, transunion: 705, equifax: 712 },
    ownerName: 'Marie Samuelle',
    ssnMasked: '***-**-6789',
    ssnLast4: '6789',
    experianScoreUsed: 710,
    transunionScoreUsed: 705,
    equifaxScoreUsed: 712,
  },
  {
    id: 'mock-app-6',
    dateOfApplication: '2025-06-15',
    lender: 'Citi',
    lendingProduct: 'Personal Credit Card',
    applicationType: 'Personal',
    personalOrBusiness: 'Personal',
    zeroPercentOffer: 'No',
    approvalAmount: 18000,
    decision: 'Approved',
    zeroPercentTerm: 'None',
    pipelineStage: 'approved',
    selectedBureauPull: 'experian',
    bureauPullScores: { experian: 723, transunion: 718, equifax: 726 },
    ownerName: 'Marie Samuelle',
    ssnMasked: '***-**-6789',
    ssnLast4: '6789',
    experianScoreUsed: 723,
    transunionScoreUsed: 718,
    equifaxScoreUsed: 726,
  },
  {
    id: 'mock-app-7',
    dateOfApplication: '2025-06-01',
    lender: 'U.S. Bank',
    lendingProduct: 'Non-Promo Business Credit Card',
    applicationType: 'Business PG',
    personalOrBusiness: 'Business',
    zeroPercentOffer: 'No',
    approvalAmount: 14000,
    decision: 'Approved',
    zeroPercentTerm: 'None',
    pipelineStage: 'approved',
    selectedBureauPull: 'experian',
    bureauPullScores: { experian: 719, transunion: 714, equifax: 722 },
    ownerName: 'Marie Samuelle',
    ssnMasked: '***-**-6789',
    ssnLast4: '6789',
    experianScoreUsed: 719,
    transunionScoreUsed: 714,
    equifaxScoreUsed: 722,
  },
  {
    id: 'mock-app-8',
    dateOfApplication: '2025-05-20',
    lender: 'TD Bank',
    lendingProduct: 'Business Loan',
    applicationType: 'Full-doc',
    personalOrBusiness: 'Business',
    zeroPercentOffer: 'No',
    approvalAmount: 19000,
    decision: 'Approved',
    zeroPercentTerm: 'None',
    pipelineStage: 'under_review',
    selectedBureauPull: 'experian',
    bureauPullScores: { experian: 724, transunion: 720, equifax: 728 },
    ownerName: 'Marie Samuelle',
    ssnMasked: '***-**-6789',
    ssnLast4: '6789',
    experianScoreUsed: 724,
    transunionScoreUsed: 720,
    equifaxScoreUsed: 728,
  },
];

const STAGE_KEYS = ['submitted', 'under_review', 'approved', 'funded'];

function resolvePipelineStage(application) {
  if (application.pipelineStage && STAGE_KEYS.includes(application.pipelineStage)) {
    return application.pipelineStage;
  }
  if (application.decision === 'Pending') return 'under_review';
  if (application.decision === 'Approved') return 'approved';
  return 'submitted';
}

/** Zeroed metrics for real clients with no application records. */
export function emptyApplicationMetrics() {
  return computeMockMetrics([]);
}

export function computeMockMetrics(applications) {
  const approved = applications.filter((a) => a.decision === 'Approved').length;
  const denied = applications.filter((a) => a.decision === 'Denied').length;
  const pending = applications.length - approved - denied;
  const totalApproval = applications
    .filter((a) => a.decision === 'Approved')
    .reduce((sum, a) => sum + (Number(a.approvalAmount) || 0), 0);
  const best = Math.max(...applications.map((a) => Number(a.approvalAmount) || 0), 0);
  const exScores = applications
    .map((a) => {
      if (a.selectedBureauPull && a.bureauPullScores?.[a.selectedBureauPull]) {
        return a.bureauPullScores[a.selectedBureauPull];
      }
      return a.experianScoreUsed;
    })
    .filter(Boolean);
  const avgEx = exScores.length ? Math.round(exScores.reduce((s, v) => s + v, 0) / exScores.length) : null;

  const amountCards = computeFundingAmountCardTotals(applications);
  const fundingByProduct = sumApprovedByProductCategories(applications);

  const stageCounts = STAGE_KEYS.reduce((acc, key) => ({ ...acc, [key]: 0 }), {});
  applications.forEach((app) => {
    const stage = resolvePipelineStage(app);
    stageCounts[stage] += 1;
  });

  const pipelineStageData = [
    { key: 'submitted', label: 'Submitted', value: stageCounts.submitted, color: PIPELINE_STAGE_COLORS.submitted },
    { key: 'under_review', label: 'Under Review', value: stageCounts.under_review, color: PIPELINE_STAGE_COLORS.under_review },
    { key: 'approved', label: 'Approved', value: stageCounts.approved, color: PIPELINE_STAGE_COLORS.approved },
    { key: 'funded', label: 'Funded', value: stageCounts.funded, color: PIPELINE_STAGE_COLORS.funded },
  ];

  return {
    totalApplications: applications.length,
    totalApproved: approved,
    totalDenied: denied,
    totalPending: pending,
    totalApprovalAmount: totalApproval,
    bestApprovalAmount: best,
    avgExperianUsed: avgEx,
    personalFundingAmount: amountCards.personalFundingAmount,
    creditCardAmount: amountCards.creditCardAmount,
    businessFundingAmount: amountCards.businessFundingAmount,
    zeroPercentCreditCardAmount: amountCards.creditCardAmount,
    businessLineOfCreditAmount: amountCards.businessFundingAmount,
    approvalRate: applications.length ? Math.round((approved / applications.length) * 100) : 0,
    pipelineStageData,
    fundingByProduct,
  };
}
